import React, {useState} from 'react'
import { motion } from 'framer-motion'
import { transition1 } from '../transitions';
import Carousel from '../components/Carousel';
import Edition2 from './Edition2';
import { useNavigate } from 'react-router-dom';


const We = () => {

  const [activeEdition, setActiveEdition] = useState("edition1")
  const navigate = useNavigate()

  return (
  <>
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='section overflow-auto lg:pt-10'
    >
    
      <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 100, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='overflow-auto lg:items-start lg:justify-start items-center justify-center flex lg:px-32 mt-10 lg:mt-18'
    >
     <div className='flex items-center self-center rounded-2xl border-2 bg-zinc-900 w-fit justify-center p-3  lg:pt-3'>
      <div onClick={() => setActiveEdition("edition1")} className={`h6 mt-2 px-4 lg:px-10 hover:text-white hover:cursor-pointer  ${activeEdition == "edition1" ? 'text-white' : 'text-gray-400'}`}>
      Edition 1
      </div>
      <div onClick={() => setActiveEdition("edition2")} className={`h6 mt-2 px-4 lg:px-10 hover:text-white hover:cursor-pointer  ${activeEdition == "edition2" ? 'text-white' : 'text-gray-400'}`}>
      Edition 2
      </div>
     </div>
     </motion.section>
     <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 100, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}>
     {activeEdition === "edition1" && (
      <>
      <div className='lg:grid lg:grid-cols-2 py-12 pb-20 mb-36 lg:mb-0 lg:py-20  lg:pt-4'>
      <div>
        <motion.section
              initial={{ opacity: 0, y: '100%' }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: '100%' }}
              transition={transition1}
              className='px-12 lg:px-32'
            >
               <div className='lg:hidden lg:flex lg:flex-col lg:items-center mb-10'>
              <Carousel/>
            </div>
            <div className='lg:flex flex-2'>
                
                <div className='flex-1 lg:py-10'>
                    <p className='lg:h4 h5'>First Edition<br/>25th November 2024</p>
                    <p><hr className="border-t border-2 border-black w-1/2 my-6" /></p>
                    <p className='text-sm lg:text-md'><span className='lg:h5 h6 h-6'>International Day for the Elimination of Violence Against Women</span>
                        <br/> <br/>
        
        The 1st Edition of WE is a collaborative piece featuring video submissions from our artists, from all around the world honoring November 25th: International Day for the Elimination of Violence Against Women. This edition will be projected in locations worldwide, focusing on confronting oppression through unity and utilizing our collective strength to challenge systemic violence and dismantle the dominant narratives of fragility.
        
        Fragility is a discourse that imprisons us all, women, and the environment. Don’t be mistaken: the systems that harm and kill us are not our saviors. The notion of “fragile ecosystems” or “fragile genders” is misleading. This project aims to unveil the so-called protective narratives and reveal the hidden violations beneath them.
        
        Isadora Canela
        Posters First Edition – Screening
        in the Following Cities: <br/><br/>
        
            <span className='font-bold'>October 31st 2024 </span> – Evia Island, Greece <br/>
            <span className='font-bold'>November 17th 2024 </span> – Genova, Italy <br/>
            <span className='font-bold'>November 24-25th 2024</span> – Norwich, UK <br/>
            <span className='font-bold'>November 25th 2024 </span> – Iceland <br/>
            <span className='font-bold'>November 25th 2024 </span> – Cuneo, Italy <br/>
            <span className='font-bold'>November 25th 2024 </span> – Pisa, Italy <br/>
            <span className='font-bold'>November 25th 2024 </span> – Berlin, Germany <br/>
            <span className='font-bold'>November 26th 2024 </span> – Suffolk, UK 
        </p>
                </div>
            </div>
            </motion.section>
      </div>
      <div className='lg:h-3/4 lg:flex lg:flex-col align-middle items-center hidden'>
        <Carousel/>
        {/* <div onClick={() => navigate("/album")} className='h4 p-2 lg:mt-10 hover:scale-110 hover:cursor-pointer border-2 border-black'>ALBUM</div> */}

      </div>
      </div>
     </>)}
     {activeEdition === "edition2" && (
      <>
      
      <Edition2/>
      </>
     )}
     </motion.section>
     
    </motion.section>
    </>
  )
}

export default We